import {
  isValidConversationLog,
  type ValidatedConversationLogDto,
} from '@shared/utils/conversationLog.utils';

import type { ConversationLogDto } from './apiService';
import type { ConversationLogsPage } from './conversationLogsApi';

interface ConversationLogPages {
  pages: ConversationLogsPage[];
}

export const pagesHaveLog = (pages: ConversationLogsPage[], id: string): boolean =>
  pages.some((page) => page.data?.some((item) => item.id === id));

// A live message joins the last page, unless a page (a REST page or an earlier push) already has it
export const appendLogToPages = (
  draft: ConversationLogPages,
  message: ConversationLogDto,
): void => {
  const lastPage = draft.pages[draft.pages.length - 1];
  if (!lastPage) return;
  if (pagesHaveLog(draft.pages, message.id)) return;

  lastPage.data = [...(lastPage.data ?? []), message];
};

export const flattenConversationPages = (
  pages: ConversationLogsPage[],
): ValidatedConversationLogDto[] => {
  const uniqueById = new Map<string, ValidatedConversationLogDto>();
  pages.forEach(({ data }) =>
    data?.filter(isValidConversationLog).forEach((message) => {
      if (!uniqueById.has(message.id)) uniqueById.set(message.id, message);
    }),
  );

  return Array.from(uniqueById.values()).sort(
    (a, b) => new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime(),
  );
};
